<template>
  <div class="cd-vp">
    <b-row class="mb-5">
      <b-col cols="3">
        <label class="font-weight-bold mb-1">Từ ngày</label>
        <b-input v-model="from" type="date" size="sm" />
      </b-col>
      <b-col cols="3">
        <label class="font-weight-bold mb-1">Đến ngày</label>
        <b-input v-model="to" type="date" size="sm" />
      </b-col>
      <b-col cols="2" class="align-self-end">
        <b-button
          size="sm"
          variant="primary"
          style="font-weight: 600; width: 130px"
          :disabled="!from || !to"
          @click="reload"
        >
          Tải báo cáo
        </b-button>
      </b-col>
    </b-row>

    <b-table
      :items="items"
      :fields="fields"
      :small="true"
      :busy="loading"
      responsive
      bordered
      hover
      show-empty
      empty-text="Không có dữ liệu — chọn khoảng ngày rồi bấm Tải báo cáo"
    >
      <template #table-busy>
        <div class="text-center text-primary my-3">
          <b-spinner small class="align-middle mr-2"></b-spinner>
          <strong>Đang tải...</strong>
        </div>
      </template>

      <template #cell(appliedCount)="data">
        {{ format(data.item.appliedCount) }}
      </template>

      <template #cell(contractCount)="data">
        {{ format(data.item.contractCount) }}
      </template>

      <template #cell(totalCommissionDeducted)="data">
        <span class="cd-amount">{{
          format(data.item.totalCommissionDeducted)
        }}</span>
      </template>
    </b-table>

    <b-row>
      <b-col>
        <p class="mt-3 text-dark" style="font-weight: 500">
          Tổng số voucher: {{ items.length }}
        </p>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { CommissionDebtService } from '@/core/services/commission-debt.service';

export default {
  name: 'VoucherPerformanceTab',
  data() {
    return {
      from: '',
      to: '',
      items: [],
      loading: false,
      fields: [
        {
          key: 'voucherCode',
          label: 'Mã voucher',
          thClass: 'text-center',
        },
        {
          key: 'appliedCount',
          label: 'Số lần áp',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '15%' },
        },
        {
          key: 'contractCount',
          label: 'Số HĐ',
          thClass: 'text-center',
          tdClass: 'text-center',
          thStyle: { width: '15%' },
        },
        {
          key: 'totalCommissionDeducted',
          label: 'Tổng commission trừ NV',
          thClass: 'text-center',
          tdClass: 'text-right',
          thStyle: { width: '25%' },
        },
      ],
    };
  },
  mounted() {
    // Default range = tháng trước (ngày 1) → cuối tháng hiện tại
    // Phòng trường hợp kế toán chưa thu xong kỳ trước.
    const now = new Date();
    const y = now.getFullYear();
    const mCur = now.getMonth(); // 0-11
    const prevDate = new Date(y, mCur - 1, 1);
    const yPrev = prevDate.getFullYear();
    const mPrev = String(prevDate.getMonth() + 1).padStart(2, '0');
    const lastDayCur = new Date(y, mCur + 1, 0).getDate();
    const mCurStr = String(mCur + 1).padStart(2, '0');
    this.from = `${yPrev}-${mPrev}-01`;
    this.to = `${y}-${mCurStr}-${String(lastDayCur).padStart(2, '0')}`;
    this.reload();
  },
  methods: {
    async reload() {
      if (!this.from || !this.to) return;
      this.loading = true;
      try {
        const res = await CommissionDebtService.voucherPerformance({
          from: this.from,
          to: this.to,
        });
        // BE wrap qua ResponseInterceptor → res.data.data.data
        this.items = res?.data?.data?.data || [];
      } catch (e) {
        this.items = [];
        const status = e?.response?.status;
        const msg =
          e?.response?.data?.message || e?.message || 'Lỗi không xác định';
        // eslint-disable-next-line no-console
        console.error('[VoucherPerformanceTab] reload error:', status, msg, e);
        this.$bvToast?.toast?.(`API lỗi (${status || '?'}): ${msg}`, {
          variant: 'danger',
          title: 'Không tải được dữ liệu',
          autoHideDelay: 8000,
        });
      } finally {
        this.loading = false;
      }
    },
    format(n) {
      return Number(n || 0).toLocaleString('vi-VN');
    },
  },
};
</script>

<style lang="scss" scoped>
.cd-vp {
  .cd-amount {
    font-weight: 600;
    color: #6366f1;
  }
}
</style>
